<!-- 入驻页-供应商入驻-验证手机号 -->
<template>
	<div class="wrap">

		<div class="header-sub">
			<div class="header-sub-middle">
				<div class="header-top">
					<img @click="$router.push('/')" src="../assets/logo-3.png" class="logo-img">
				</div>

			</div>
		</div>

		<p class="top-title">供应商入驻申请</p>

		<div class="middle-container">
			<div class="form">

				<div class="process-wrap">
					<div class="process active">
						<span class="process-label">验证手机号</span>
						<span class="circle" :class="{bg: currentStep >= 1}">1</span>
					</div>
					<div class="process">
						<span class="process-label">企业认证</span>
						<span class="circle" :class="{bg: currentStep >= 2}">2</span>
					</div>
					<div class="process">
						<span class="process-label">授权条例</span>
						<span class="circle" :class="{bg: currentStep >= 3}">3</span>
					</div>
					<div class="process">
						<span class="process-label">订购服务</span>
						<span class="circle" :class="{bg: currentStep >= 4}">4</span>
					</div>
				</div>

        <entry-verification-number-step1
            v-show="currentStep === 1"
            @next="currentStep = 2"
        />
        <entry-verification-number-step2
            v-show="currentStep === 2"
            v-model="params"
            @next="next2"
            @prev="currentStep = 1"
        />
        <entry-verification-number-step3
            v-show="currentStep === 3"
            v-model="params"
            @next="next3"
            @prev="currentStep = 2"
        />
        <entry-verification-number-step4
            v-show="currentStep === 4"
            :result="result"
            @reset="currentStep = 2"
        />
			</div>
		</div>

	</div>
</template>

<script>
import EntryVerificationNumberStep1 from "@/components/entry-verification-number-step-1";
import EntryVerificationNumberStep2 from "@/components/entry-verification-number-step-2";
import EntryVerificationNumberStep3 from "@/components/entry-verification-number-step-3";
import EntryVerificationNumberStep4 from "@/components/entry-verification-number-step-4";
import {validatorFun} from "@/common/util";
import {BASE_URL} from "@/common/config";
import {MemberService, SupplierExamineService} from "@/common/service";
import {Message} from "element-ui";
  export default {
    components: {
      EntryVerificationNumberStep1,
      EntryVerificationNumberStep2,
      EntryVerificationNumberStep3,
      EntryVerificationNumberStep4,
    },
    data() {
      const params = {
        // 加盟商性质
        nature: '企业',
        // 公司名称
        corporate: '',
        // 社会信用代码
        credit_code: '',
        // 商品授权证书编码
        trademark: '',
        // 营业执照
        business_image: '',
        // logo
        logo_image: '',
        // 商品授权证书
        trademark_image: '',
      };
      return {
        BASE_URL,
        params,

        currentStep: 1,

        result: {},

        userInfo: {},
			};
		},
    watch: {
      params: {
        deep: true,
        handler(obj) {
          this.validatorNullResult = validatorFun(obj, this.validatorNullList);
        },
      }
    },
		mounted() {
      this.getUserInfo().then(() => {
        if (this.userInfo.member_id > 0) {
          this.currentStep = 2;
          this.getResult();
        }
      })
    },
		methods: {

      next2() {
        const validatorNullList = [
          ['corporate', ['notNull', '请填写公司名称']],
          ['credit_code', ['notNull', '请填写社会信用代码']],
          ['business_image', ['notNull', '请上传营业执照']],
          ['logo_image', ['notNull', '请上传logo']],
        ];
        const validatorNullResult = validatorFun(this.params, validatorNullList);
        if (validatorNullResult.length > 0) {
          return Message.warning(validatorNullResult[0].errMsg);
        }
        this.currentStep = 3;
      },
      next3() {
        const validatorNullList = [
          ['trademark', ['notNull', '请填写商品授权证书编码']],
          ['trademark_image', ['notNull', '请上传商品授权证书']],
        ];
        const validatorNullResult = validatorFun(this.params, validatorNullList);
        if (validatorNullResult.length > 0) {
          return Message.warning(validatorNullResult[0].errMsg);
        }
        SupplierExamineService.addexamine(this.params).then(() => {
          Message.success('提交成功');
          this.getResult();
        });
      },

      getResult() {
        return SupplierExamineService.info().then(({data}) => this.result = data || {id: 0}).then(() => {
          if (this.result.id > 0) {
            this.currentStep = 4;
          }
        });
      },
      getUserInfo() {
        return MemberService.info().then(({data}) => {
          this.userInfo = data;
          localStorage.setItem('user_info', JSON.stringify(this.userInfo));
        }).catch(() => {
          this.userInfo = { member_id: 0 };
          localStorage.setItem('user_info', JSON.stringify(this.userInfo));
        });
      },
    },
	};
</script>

<style scoped>
	.wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding-top: 137px;
		background-color: #FFFFFF;
	}

	.header-sub {
		width: 100%;
		height: 139px;
		background-color: #F8F5ED;
		position: fixed;
		top: 44px;
		left: 0;
		z-index: 99;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.header-sub-middle {
		width: 1200px;
		height: 100%;
		display: flex;
		flex-direction: column;
		padding: 0 75px 0 35px;
		box-sizing: border-box;
	}

	.header-top {
		width: 100%;
		height: 130px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.logo-img {
		width: 224px;
	}

	.footer {
		width: 100%;
		height: 271px;
		background-color: #FFFFFF;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.footer-middle {
		width: calc(1200px - 292px);
		display: flex;
		flex-direction: column;
	}

	.footer-tag-list {
		width: 100%;
		display: flex;
		align-items: center;
	}

	.footer-tag-list>li {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #333333;
		font-size: 16px;
		font-weight: bold;
	}

	.footer-tag-icon {
		width: 56px;
		margin-bottom: 14px;
	}

	.footer-bottom {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 8px;
		box-sizing: border-box;
		margin-top: 37px;
	}

	.footer-bottom-left {
		flex: 1;
		display: flex;
		align-items: center;
		margin-right: 135px;
	}

	.footer-bottom-left-list {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}

	.footer-bottom-left-list>li {
		width: 33.3333%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #666666;
		font-size: 16px;
		font-weight: bold;
		margin-top: 15px;
	}

	.footer-bottom-left-list>li:first-child,
	.footer-bottom-left-list>li:nth-child(2),
	.footer-bottom-left-list>li:nth-child(3) {
		margin-top: 0;
	}

	.footer-bottom-right {
		display: flex;
		align-items: center;
	}

	.footer-bottom-right-img {
		width: 48px;
		margin-right: 7px;
	}

	.footer-bottom-right-row {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
	}

	.footer-font1 {
		color: #C69236;
		font-size: 28px;
		font-weight: bold;
	}

	.footer-font2 {
		color: #333333;
		font-size: 16px;
		font-weight: bold;
	}

	.middle-container {
		width: 1200px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.form-row {
		width: 352px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 30px;
	}

	.form-label {
		width: 83px;
		font-weight: bold;
		font-size: 16px;
		color: #333333;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding-right: 5px;
		box-sizing: border-box;
	}

	.form-input-box {
		flex: 1;

	}

	.form {
		width: 707px;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 40px 0;
	}

	>>>.el-input__inner {
		border-radius: 8px !important;
		border: 1px solid #666666 !important;
		color: #606266 !important;
		height: 30px !important;
		line-height: 30px !important;
	}

	>>>.el-input__inner::placeholder {
		color: #999999 !important;
	}

	.upload-wrap {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.upload-module {
		display: flex;
		align-items: flex-start;
		margin-right: 60px;
	}

	.upload-module:last-child {
		margin-right: 0;
	}

	.upload-label {
		color: #333333;
		font-size: 16px;
		font-weight: bold;
	}

	.upload-box {
		width: 208px;
		height: 135px;
	}

	.upload-img {
		width: 100%;
		height: 100%;
	}

	.btn-box {
		width: 100%;
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}

	.btn-box>button {
		width: 152px;
		height: 36px;
		line-height: 36px;
		background-color: #FF6619;
		border-radius: 8px;
		color: #FFFFFF;
		font-size: 16px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right: 14px;
		box-sizing: border-box;
	}

	.btn-box>button:last-child {
		margin-right: 0;
	}

	.btn-box>button.border-btn {
		border: 1px solid #666666;
		color: #666666;
		background-color: #EEEEEE;
	}

	.top-title {
		width: 100%;
		height: 50px;
		line-height: 50px;
		background: linear-gradient(180deg, #F3DC99, #F0AE46);
		font-size: 24px;
		font-weight: bold;
		color: #FFFFFF;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.process-wrap {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		padding-bottom: 34px;
	}

	.process {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;
	}

	.process::after {
		content: "";
		position: absolute;
		left: calc(50% + 18px);
		bottom: 18px;
		width: calc(100% - 36px);
		height: 2px;
		background-color: #FF6619;
	}

	.process:last-child::after {
		background-color: initial;
	}

	.process-label {
		color: #333333;
		font-size: 16px;
		font-weight: bold;
		margin-bottom: 12px;
	}

	.circle {
		width: 36px;
		height: 36px;
		line-height: 36px;
		border: 2px solid #999999;
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 20px;
		font-weight: bold;
		color: #999999;
		box-sizing: border-box;
	}

	.circle.border {
		border: 2px solid #FF6619;
		color: #F37C3D;
	}

	.circle.bg {
		background-color: #FF6619;
		color: #FFFFFF;
		border: none;
	}

	.process.active .process-label {
		color: #FF6619;
	}

	.get-code-btn {
		color: #FFFFFF;
		font-size: 16px;
		width: 112px;
		height: 30px;
		line-height: 30px;
		background-color: #FF6619;
		border-radius: 8px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-left: 5px;
	}
</style>
